import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  mobileHeading: {
    display: 'none',
    '@media(max-width: 768px)': {
      display: 'flex',
      fontSize: '2.6rem',
      justifyContent: 'center'
    },
    '@media(max-width: 480px)': {
      fontSize: '2rem'
    }
  },
  stepButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    '@media(max-width: 480px)': {
      flexDirection: 'column-reverse'
    }
  },
  stepButtonsLeft: {

  },
  stepButtonsRight: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  stepButtonsCenter: {
    display: 'flex',
    justifyContent: 'center'
  },
  stepButton: {
    width: 200,
    '@media(max-width: 480px)': {
      marginBottom: 10,
      width: '100%'
    }
  },
  stepContainer: {
    display: 'flex',
    // margin: 35,
    width: '100%',
    boxSizing: 'border-box',
    '@media(max-width: 768px)': {
      flexDirection: 'column-reverse',
      width: '100%',
      justifyContent: 'flex-end'
    },
    '@media(max-width: 480px)': {
      margin: 20,
    },
    '& .errorMessage': {
      width: '100%',
      margin: '0 0 32px 0',
      '& .MuiCollapse-root': {
        margin: '0 0 25px 0',
        '&.MuiCollapse-hidden': {
          margin: '0',
        }
      },
      '& .MuiAlert-action': {
        position: 'absolute',
        right: -13,
        margin: '0 !important',
        top: -8,
        padding: 0,
      },
      '& .MuiPaper-root': {
        position: 'relative',
        padding: '6px 20px',
        width: '100%',
        boxSizing: 'border-box'
      },
      '& .MuiCollapse-wrapperInner': {
        margin: 0,
        '& .MuiAlert-message': {
          padding: '13px 25px 13px 10px',
          width: '100%',
          boxSizing: 'border-box',
          display: 'block',
          margin: 0,
          '& strong': {
            textTransform: 'uppercase'
          }
        }
      },
    }
  },
  stepSection: {
    padding: 30,
    '@media(max-width: 480px)': {
      padding: 20,
    }
  },
  stepSectionSkipLink: {
    position: 'absolute',
    right: 30,
    fontSize: 16,
    letterSpacing: '-0.5px',
    fontWeight: 500,
    fontFamily: "'CircularStd', Helvetica, Arial, Verdana, Tahoma, sans-serif",
    color: '#2d91e9',
    top: 30,
    cursor: 'pointer',
    padding: 0,
    minHeight: 0,
    height: 'auto',
    lineHeight: '1.1',
    background: 'none',
    border: 'none'

  },
  stepSectionCopyWrapper: {
    marginBottom: 20
  },
  stepSectionHeading: {
    fontWeight: 500,
    marginBottom: 5,
    '& svg': {
      verticalAlign: 'top'
    }
  },
  stepSectionBody: {
    color: '#a4a4a4'
  },
  stepForm: {
    marginRight: '5%',
    width: '95%',
    minWidth: 320,
    maxWidth: 600,
    '@media(max-width: 768px)': {
      margin: '0 auto',
      width: '100%',
      '& > div > h4': {
        display: 'none'
      }
    },
    '& .MuiFormLabel-root': {
      '&.Mui-error': {
        color: '#f44336'
      }
    }
  },
  stepTracker: {
    marginTop: 60,
    width: '300px',
    '@media(max-width: 768px)': {
      marginTop: 30,
      width: '100%',
      justifyContent: 'center',
      marginBottom: 30,
    },
    '@media(max-width: 480px)': {
      marginTop: 25,
      marginBottom: 25,
    }
  },
  show: {
    transition: "opacity 0.7s linear",
    zIndex: 100,
    border: "1px red solid",
    position: "absolute",
    width: "100%",
    height: "100%"
  },
  hide: {
    opacity: 0
  }
});
